import { ServerConfig } from "@/config/config";
import {Company} from "@/models/company";

export class User {
	id:number = 0;
	username:string = "";
	email:string = "";
	firstname:string = "";
	lastname:string = "";
	companyId:number = 0;
	isOwner:boolean = false;
	activated:boolean = false;
	phone:string = "";
	totpEnabled:boolean = false;
	dateCreated:Date = new Date();
	profileImg:string = "";
	company:Company = new Company();
	deviceId:number = 0;

	QuietMode: boolean = false;
	isAccountant:boolean = false;
	lang:string = "nl-be";
	restrictedToIpAddresses:string[] = [];

	constructor(data:any = null) {
		if (!data) return;
		this.id = data.ID;
		this.username = data.Username;
		this.firstname = data.Firstname;
		this.lastname = data.Lastname;
		this.email = data.Email;
		this.companyId = data.CompanyID;
		this.activated = data.Activated;
		this.phone = data.Phone;
		this.totpEnabled = data.TotpEnabled;
		this.dateCreated = new Date(data.DateCreated);
		this.profileImg = data.ProfileImg;
		this.deviceId = data.DeviceID;
		this.QuietMode = data.QuietMode;
		this.isAccountant = data.IsAccountant;
		this.lang = data.Lang || "nl-be";
		this.restrictedToIpAddresses = [...(data.RestrictedToIPAddresses || [])];
		if(data.Company){
			this.company = new Company(data.Company);
			this.isOwner = this.company.ownerId == data.ID;
		}
	}

	getJSON() {
		return {
			ID: this.id,
			Username: this.username,
			Firstname: this.firstname,
			Lastname: this.lastname,
			Email: this.email,
			CompanyID: this.companyId,
			Activated: this.activated,
			Phone: this.phone,
			TotpEnabled: this.totpEnabled,
			DateCreated: this.dateCreated.toJSON(),
			ProfileImg: this.profileImg,
			Company: this.company,
			IsOwner: this.isOwner,
			DeviceID: this.deviceId,
			QuietMode: this.QuietMode,
			IsAccountant: this.isAccountant,
			Lang: this.lang,
			RestrictedToIPAddresses: this.restrictedToIpAddresses
		};
	}

	public toString(){
		let result = `${this.company.name} <span class='mls user'>${this.firstname} ${this.lastname}</span>`;
		/*if (this.email != ""){
			result += ` - ${this.email}`  ;
		}else if (this.username != ""){
			result += ` - ${this.email}`;
		}*/

		if(this.isOwner){
			result += ` <span class='mls owner'>Eigenaar</span>`;
		}

		if(this.company.isDemo){
			result += ` <span class='mls demo'>Demo</span>`;
		}
		return result.trim();
	}

	public combineWithCompany(company: Company){
		let result = `<div>${company.name}</div>`;
		result += `<div>${this.email} ${this.lastname} | ${this.email}<div>`;
		return result.trim();
	}

	public getProfileImgUrl():string{
		return `${ServerConfig.host}/files/${this.profileImg}`;
	}

	public getUserString():string {
		return `${this.firstname} ${this.lastname} (${this.email || this.username})`;
	}

}
